export default "__VITE_ASSET__CK5TRdRb__"